@import "../../variables.scss";

.resourceFolder {
  &__wrapper {
    border: #d0d0d0 1px solid;
    margin: 1rem 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;

    @media (max-width: $size-sm) {
      margin: 0 0 15px;
      padding: 0;
      border: unset;
    }
  }

  &__contentWrapper {
    display: flex;
    flex-direction: row;
  }

  &__textWrapper {
    height: auto;
    flex-basis: 35%;
    display: flex;
    flex-direction: column;
  }

  &__imgWrapper {
    max-height: 300px;
    width: 100%;
    height: auto;
    flex-basis: 65%;
    display: flex;
    justify-content: flex-end;
  }

  &__title {
    @media (max-width: 400px) {
      background-color: rgba(0, 30, 83, 0.2);
      margin: 0px -1rem;
      padding: 1rem;
    }
  }

  &__description {
    color: $color-grey;
    width: auto;
  }

  &__button {
    width: 120px;
    height: 40px;
    margin-top: 10px;
  }

  &__img {
    width: 100%;
    height: 100%;
  }
}
